import { isRef, type MaybeRef, type ShallowRef } from "vue";

export const uref = <T = any>(x: MaybeRef<T> | T | ShallowRef<T>): T => {
  if (typeof x === 'undefined' || x === null) return x;
  return isRef(x) ? x.value : x;
}


export const refPeek = <T = any>(x: MaybeRef<T> | T | ShallowRef<T>): T => {
  if (typeof x === 'undefined' || x === null) return x;
  return isRef(x) ? Reflect.get(x, 'value') : x;
}
